import { useEffect } from "react";

import { useIsAuthenticated, useMsal } from "@azure/msal-react";
import { useNavigate } from "@tanstack/react-router";

import { DEFAULT_PROTECTED_ROUTE } from "../../constants/auth";
import { isUserAuthenticated } from "../../utils/tokenManager";
import { HeroSection } from "./components/section-hero";

const Landing = () => {
  const navigate = useNavigate();
  const isAuthenticated = useIsAuthenticated();
  const { instance } = useMsal();

  useEffect(() => {
    const checkAuthAndToken = async () => {
      try {
        // First, handle any pending redirect promise (user returning from login)
        const redirectResponse = await instance.handleRedirectPromise();
        if (redirectResponse?.account) {
          // User just completed login, set active account
          instance.setActiveAccount(redirectResponse.account);
        }

        // Check if there's a valid token in cookies
        const hasValidTokenInCookies = isUserAuthenticated();
        const hasAccounts = instance.getAllAccounts().length > 0;

        // External (email-code) users have a valid app token but no MSAL account.
        if (!isAuthenticated && !hasAccounts && hasValidTokenInCookies) {
          navigate({ to: DEFAULT_PROTECTED_ROUTE });
          return;
        }

        // Only navigate if both MSAL is authenticated and we have valid cookies
        if (isAuthenticated && hasValidTokenInCookies) {
          navigate({ to: DEFAULT_PROTECTED_ROUTE });
        } else if (hasAccounts && hasValidTokenInCookies) {
          // If we have accounts and token but MSAL says not authenticated, set active account
          const accounts = instance.getAllAccounts();
          if (accounts.length > 0) {
            instance.setActiveAccount(accounts[0]);
            navigate({ to: DEFAULT_PROTECTED_ROUTE });
          }
        }
        // If no token and no accounts, user is not signed in - just show landing page
        // Don't call logoutUser here as it clears MSAL state and interferes with sign-in flow
      } catch (error) {
        console.error("Error in Landing authentication check:", error);
        // Don't call logoutUser during sign-in flow - let MSAL handle it
      }
    };

    checkAuthAndToken();
  }, [isAuthenticated, navigate, instance]);

  return <HeroSection />;
};

export default Landing;
